import { Component, Input } from '@angular/core';
import { DebateBasicData } from '../../../core/models/debates/shared/debate-basic-data';

@Component({ 
    selector: 'app-debate-basic-data',
    templateUrl: './debate-basic-data.component.html',
    styleUrls: ['./debate-basic-data.component.css']
})
export class DebateBasicDataComponent {
    @Input() debateBasicData: DebateBasicData;
}
